import { mapState } from 'vuex';
import ApiService from '@/services/apiService';
import { uniq } from 'lodash';
export default {
  name: 'Groups',
  props: {
    deviceMeta: {
      type: Object,
      required: true
    },
    tenantId: {
      type: Number,
      required: true
    },
    label: {
      type: String,
      default: '',
      required: false
    },
    readonly: {
      type: Boolean,
      optional: true,
      default: false
    }
  },
  data: function () {
    return {
      search: '',
      items: []
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'color'])
  },
  mounted() {
    this.fetchGroups();
  },
  methods: {
    process(item, remove) {
      if (!remove && item) {
        this.items.push(item[item.length - 1]);
      }
      this.search = '';
      this.$emit('groupsChosen', this.deviceMeta);
    },
    remove(item) {
      this.deviceMeta.groups.splice(this.deviceMeta.groups.indexOf(item), 1);
      this.deviceMeta.groups = [...this.deviceMeta.groups];
      this.process(item, true);
    },
    fetchGroups() {
      ApiService.virtualDeviceFetchGroups(this, [this.tenantId]).then(res => {
        this.items = uniq(res.groupList.concat(this.deviceMeta.groups)) || [];
      }).catch(error => {
        this.$snack(this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.snacks.fetchGroupsError'), 'error');
        console.error(error);
      });
    },
    restrictCharacters(event) {
      if (event.key === ',' || event.key === ';') {
        event.preventDefault();
      }
    }
  }
};